import { render } from "./Introducer.vue?vue&type=template&id=67f2b622&scoped=true"
import script from "./Introducer.vue?vue&type=script&lang=js"
export * from "./Introducer.vue?vue&type=script&lang=js"

import "./Introducer.vue?vue&type=style&index=0&id=67f2b622&lang=scss&scoped=true"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f2b622"]])

export default __exports__